import React from "react";
import { classNames } from "../../helpers/classNames";

const Checkbox = ({
  checkboxName,
  checkboxInputClass,
  isChecked,
  checkboxClass,
  checkboxLabel,
  checkboxLableClass,
  strike = false,
  checked,
  divClass,
  isDisabled = false,
  onChange = () => {},
  value,
  altView = false,
  errorText,
  errorType,
  ...props
}) => {
  return (
    <>
      <label
        className={classNames(
          "relative overflow-hidden flex items-center flex-shrink-0 w-fit",
          divClass
        )}
      >
        <input
          type="checkbox"
          name={checkboxName}
          className={classNames(
            "peer absolute top-0 left-0 w-5 h-5 opacity-0 z-10 cursor-pointer ",
            checkboxInputClass
          )}
          value={value}
          defaultChecked={isChecked}
          checked={checked}
          onChange={onChange}
          isDisabled={isDisabled}
        />
        <div
          className={classNames(
            "w-5 h-5 flex-shrink-0 border  rounded flex items-center justify-center text-sm ",
            altView
              ? "bg-primary text-white border-primary peer-checked:bg-green-500 peer-checked:border-green-500 peer-checked:text-white"
              : "border-text-secondary/50 bg-white text-black/0 peer-checked:bg-primary peer-checked:border-primary peer-checked:text-white",
            checkboxClass
          )}
        >
          {altView ? (
            checked ? (
              <i className="fa-light fa-check"></i>
            ) : (
              <i className="fa-light fa-xmark"></i>
            )
          ) : (
            <i className="fa-light fa-check"></i>
          )}
        </div>
        {checkboxLabel && (
          <div
            className={classNames(
              "text-xs text-sidebar    w-full ml-3 transition-all duration-200",
              strike ? "peer-checked:line-through" : "",
              checkboxLableClass
            )}
          >
            {checkboxLabel}
          </div>
        )}
      </label>
      {errorType && errorType === "error" && (
        <div className="text-xs text-red-600 mt-1">
          <i className="fa-regular fa-fw fa-square-exclamation text-sm mr-1"></i>
          {errorText}
        </div>
      )}
      {errorType && errorType === "warning" && (
        <div className="text-xs text-amber-500 mt-1">
          <i className="fa-regular fa-fw fa-triangle-exclamation text-sm mr-1"></i>
          {errorText}
        </div>
      )}
      {errorType && errorType === "success" && (
        <div className="text-xs text-green-600 mt-1">
          <i className="fa-regular fa-fw fa-circle-check text-sm mr-1"></i>
          {errorText}
        </div>
      )}
      {errorType && errorType === "info" && (
        <div className="text-xs text-sky-600 mt-1">
          <i className="fa-regular fa-fw fa-circle-info text-sm mr-1"></i>
          {errorText}
        </div>
      )}
    </>
  );
};

export default Checkbox;
